import { render, staticRenderFns } from "./ElectronContent.vue?vue&type=template&id=22fa633f&scoped=true&"
import script from "./ElectronContent.vue?vue&type=script&lang=js&"
export * from "./ElectronContent.vue?vue&type=script&lang=js&"
import style0 from "./ElectronContent.vue?vue&type=style&index=0&id=22fa633f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fa633f",
  null
  
)

export default component.exports